var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-form-tooltip",class:['bg-' + _vm.variant, _vm.right ? 'right' : 'left', {'no-triangle': _vm.noTriangle}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }